// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1pWrs","header":"ReportDetails_header__3j6F1","title":"ReportDetails_title__2ihcb","left":"ReportDetails_left__2NayF"};